<template>
    <v-list-item three-line>
        <v-list-item-content class="overflow-visible">
            <v-row>
                <v-col cols="12" md="12" class="d-flex px-0">
                    <v-text-field
                            v-model="filterForm.keyword"
                            class="search-name-contact pt-0"
                            placeholder="Tìm kiếm theo sdt, mkh, mã đơn hàng..."
                            clearable
                            @keyup.enter="searchContact"
                            style="margin-top: -26px; margin-right: 30px;"
                    />
                    <div class="group-btn-search">
                        <v-menu
                                :internal-activator="true"
                                v-model="filterForm.closeMenu"
                                content-class="menu__customer no-contain overflow-visible"
                                :close-on-content-click="false"
                        >
                            <template v-slot:activator="menuON">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                                icon
                                                medium
                                                color="white"
                                                v-on="on"
                                                class="search-contact--dropdown"
                                        >
                                            <v-icon size="20"
                                                    v-on="menuON.on"
                                            >mdi-chevron-down</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Tìm kiếm nâng cao</span>
                                </v-tooltip>
                            </template>
                            <card-filter-form
                                    :filterForm="filterForm"
                                    :productGroups="productGroups"
                                    :contactStatusList="contactStatusList"
                                    :contactSources="contactSources"
                                    :users="users"
                                    :productList="productList"
                                    :schoolLevelList="schoolLevelList"
                                    :inactiveUsers="inactiveUsers"
                                    :provinceList="provinceList"
                            />
                        </v-menu>
                        <v-btn class="search-contact--text" small color="primary mx-0" @click="searchContact">
                             <span class="mr-3">Tìm kiếm</span>
                        </v-btn>
                    </div>
                </v-col>
                <!-- -->
            </v-row>
        </v-list-item-content>
    </v-list-item>
</template>
<script>
    import CardFilterForm from './CardFilterForm';
    export default {
        components: { CardFilterForm },
        props: {
            users: {
                type: Array,
                default: () => []
            },
            productGroups: {
                type: Array,
                default: () => []
            },
            contactStatusList: {
                type: Array,
                default: () => []
            },
            contactSources: {
                type: Array,
                default: () => []
            },
            filterForm: {
                default: () => ({})
            },
            productList: {
                default: () => []
            },
            schoolLevelList: {
              default: () => []
            },
            inactiveUsers: {
                default: () => []
            },
            provinceList: {
                default: () => []
            },
            // usersContactAdvise: {
            //   default: () => []
            // },
            // ministries: {
            //   default: () => []
            // }
        },
        computed: {
            selectContactStatusList() {
                const contactStatusList = [];
                const checkType = {};
                this.contactStatusList.forEach(contactStatus => {
                    const typeContactStatus = contactStatus.type;
                    if (!checkType[typeContactStatus]) {
                        checkType[typeContactStatus] = true;
                        if (contactStatusList.length > 0) {
                            contactStatusList.push({ divider: true });
                        }
                        contactStatusList.push({ header: typeContactStatus });
                    }
                    contactStatusList.push(contactStatus);
                });
                return contactStatusList;
            }
        },
        methods: {
            searchContact() {
                Bus.$emit('contact-list-filter', this.filterForm);
            },
            remove(item) {
                const filterFormTemp = this.filterForm;
                const index = filterFormTemp.userIds.indexOf(item.id);
                if (index >= 0) filterFormTemp.userIds.splice(index, 1);
            }
        }
    };
</script>
<style scoped>
    /deep/.m--contact-assignedAt .daterangepicker.openscenter {
        left: calc(50% + 100px) !important;
    }
    /deep/.m--contact-appointmentAt .daterangepicker.openscenter {
        left: 0 !important;
    }
    .group-btn-search {
        position: absolute;
        top: 8px;
        right: 0px;
        max-width: 130px;
    }
    .group-btn-search .search-contact--dropdown{
        position: absolute;
        right: -10px;
        z-index: 1;
        top: -7px;
    }
    .menu__customer {
        top: calc(20% - 75px) !important;
        left: 96% !important;
        transform: translateX(-96%) !important;
    }
    /deep/.search-name-contact .v-input__slot{
        width: calc(95% - 50px);
    }
    /deep/.search-name-contact input{
        font-size: 13px !important;
    }
</style>
